import React, {useState} from 'react';
import {Link} from "react-router-dom";

import {RtMonitoringPageResult} from '../../../../server/routes/monitoring.js'

interface MonitoringProps {
	server: string
	pageData: unknown;
}

export default function Monitoring({pageData}: MonitoringProps) {

	const [data, setData] = useState(pageData as RtMonitoringPageResult);

	return (
	<>
		<div className="row row-50 justify-content-xl-between align-items-center flex-md-row-reverse">
			<div className="unit unit-spacing-1 align-items-center">
				<div className="unit-body">
					<h3>Continuous Monitoring</h3>
					<p className="big">Monitor technology changes on any domain or safeguard your website with our advanced automatic security scans.</p>       
					<br/>
					<p className="big"  style={{color: 'red'}}> Security monitoring requires proof of ownership, which is easily verified by <b>registering with your domain email</b>.</p>                 
				</div>
			</div>
			<div className="col-md-8 col-lg-6 col-xl-6">
				<div className="block-4 offset-top-4">
				<ul className="list-marked list-marked_secondary">
				<li><strong>Effortless Setup</strong>
					<br/>
					Simply add your website, and we'll handle the monitoring.	
				</li>	
				<li><strong>Stay Informed</strong>
				<br/>
				Receive automatic email notifications about changes in your target website's technology profile.
				<br/>
				Get notified when new vulnerabilities are discovered in technologies deployed on your website.
				</li>
				<li><strong>Proactive Protection</strong>
				<br/>
				Benefit from daily updates to our vulnerability database, automatically applied to all scans.
				</li>				
				<li><strong>Automatic scheduling</strong>
				<br/>
				By automating the scanning process, we ensure continuous protection without requiring manual intervention.
				</li>
				</ul>
				<p>
					<ul>
						<li>
							<Link 
								target="_blank" 
								to={`/monitoring/sample`}
								className="link-hover" 
								title={`Sample Monitoring Report`} 
							>
								Sample Monitoring Report&nbsp;
								<span className="icon text-right fa fa-external_link"></span>
							</Link>							
						</li>
						<li>
							<Link 
								target="_blank" 
								to={`/monitoring/sample-notification-email`}
								className="link-hover" 
								title={`Example Monitoring Notification Email`} 
							>
								Example Monitoring Notification Email&nbsp;
								<span className="icon text-right fa fa-external_link"></span>
							</Link>							
						</li>
						</ul>		
					</p>
				</div>
			</div>
		</div>
		<div className="row row-50 justify-content-xl-between align-items-center flex-md-row-reverse">
			{
				!!data.MonitoredWebsitesCount &&
				<Link                     
					to={`/monitoring/websites`}
					className="button button-secondary" 
					title={`Scan website`} 
					rel="noopener nofollow" 
				>
					Review Website Monitoring
				</Link>	
			}
			{
				!data.MonitoredWebsitesCount &&
				<Link                     
					to={`/monitoring/add-website`}
					className="button button-secondary" 
					title={`Scan website`} 
					rel="noopener nofollow" 
				>
					Setup Website Monitoring
				</Link>	
			}
		</div>
		<br/>
		<br/>
	</>
	)
}
